import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { rgba } from 'polished'
import ButtonNew from 'presentation/shared/components/ButtonNew'

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Section = styled.div`
  /* border: 1px solid red; */
`

export const StyledGridItem = styled(Grid)`
  margin-bottom: 8px;
`

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
`

export const RNInputWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  flex-wrap: nowrap;

  > div {
    width: 100%;
    &:first-child {
      max-width: 40px;
      min-width: 40px;
      input {
        background-color: ${({ theme }) => theme.ds.colors.primary50};
        border: 1px solid
          ${({ theme }) => rgba(theme.ds.colors.primary600, 0.5)};
        color: ${({ theme }) => theme.ds.colors.primary800};
        font-weight: 500;
        font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        height: 40px;
        padding: 0;
        text-align: center;
      }
    }
  }
`

export const ClearButton = styled(ButtonNew)`
  background-color: ${({ theme }) => theme.ds.colors.neutral100};
  color: ${({ theme }) => theme.ds.colors.textSecondary};
  font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
  outline: none;
  border: none;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.ds.colors.neutral200};
    color: ${({ theme }) => theme.ds.colors.neutral900};
  }
`
